import { get } from "lodash";

import { useAppContext } from "../context";
import { getTeamID } from "../helper";
import { GET_VARIABLES } from "../graphql/queries";
import { useQuery } from '@apollo/react-hooks';

export function useVariable(key) {
    const { currentUser } = useAppContext();
    const teamId = getTeamID(currentUser);

    const variableKey = `${teamId}${key}`;
    const { data } = useQuery(GET_VARIABLES, {
        variables: {
            filter: {
                search: variableKey,
            },
        },
    });

    return checkVariable(data);
}

function checkVariable(res) {
    const value = get(res, "variables[0].value") || "";
    if (!value) return false;

    try {
        return JSON.parse(value);
    } catch(err) {
        console.log('[checkVariable] - error:', err)
    }
}
